// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._18m91wug{overflow-y:auto}
._1bsbauwl{width:100vw}
._1reo15vq{overflow-x:hidden}
._1reo1wug{overflow-x:auto}
._4t3i1kxc{height:100vh}
._o5721q9c{white-space:nowrap}
._s7n4nkob{vertical-align:middle}
._y3gn1h6o{text-align:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-viewer/dist/esm/viewers/svg/ImageWrapper-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,eAAe;AAC1B,WAAW,WAAW;AACtB,WAAW,iBAAiB;AAC5B,WAAW,eAAe;AAC1B,WAAW,YAAY;AACvB,WAAW,kBAAkB;AAC7B,WAAW,qBAAqB;AAChC,WAAW,iBAAiB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._18m91wug{overflow-y:auto}\n._1bsbauwl{width:100vw}\n._1reo15vq{overflow-x:hidden}\n._1reo1wug{overflow-x:auto}\n._4t3i1kxc{height:100vh}\n._o5721q9c{white-space:nowrap}\n._s7n4nkob{vertical-align:middle}\n._y3gn1h6o{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
